var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebsites(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FF932A"
    },
    points: "123.184,465.46 7.604,465.46 7.604,46.54 504.396,46.54 504.396,465.46 123.184,465.46 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.604,
    y: 46.54,
    style: {
      fill: "#02DEAE"
    },
    width: 496.792,
    height: 53.444
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.416,
    y: 64.861,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.208,
    height: 16.804
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.832,
    y: 64.861,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.208,
    height: 16.804
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.248,
    y: 64.861,
    style: {
      fill: "#FFFFFF"
    },
    width: 15.208,
    height: 16.804
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.166,
    y: 143.076,
    style: {
      fill: "#FFFFFF"
    },
    width: 195.675,
    height: 15.208
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.166,
    y: 173.492,
    style: {
      fill: "#FFFFFF"
    },
    width: 195.675,
    height: 15.208
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.166,
    y: 203.908,
    style: {
      fill: "#FFFFFF"
    },
    width: 195.675,
    height: 15.208
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.172,
    y: 244.462,
    style: {
      fill: "#FFFFFF"
    },
    width: 414.669,
    height: 15.208
  })), /*#__PURE__*/React.createElement("rect", {
    x: 56.511,
    y: 150.68,
    style: {
      fill: "#02DEAE"
    },
    width: 181.238,
    height: 60.832
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 49.172,
    y: 376.751,
    style: {
      fill: "#FFFFFF"
    },
    width: 117.273,
    height: 15.208
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.172,
    y: 407.167,
    style: {
      fill: "#FFFFFF"
    },
    width: 117.273,
    height: 15.208
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F64B65"
    },
    cx: 107.804,
    cy: 323.28,
    r: 30.659
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFF5C6"
    },
    cx: 405.21,
    cy: 323.28,
    r: 30.659
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 346.568,
    y: 376.751,
    style: {
      fill: "#FFFFFF"
    },
    width: 117.273,
    height: 15.208
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.568,
    y: 407.167,
    style: {
      fill: "#FFFFFF"
    },
    width: 117.273,
    height: 15.208
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#37B3CC"
    },
    cx: 256.507,
    cy: 323.28,
    r: 30.659
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002770"
    },
    d: "M0,38.936v68.652v365.476h512V107.588V38.936H0z M496.792,457.856H15.208V107.588h370.495V92.38 H15.208V54.144h481.584V92.38h-90.812v15.208h90.812V457.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002770"
    },
    d: "M245.354,143.073H48.907v76.04h196.448V143.073z M230.147,203.905H64.115v-45.624h166.032V203.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002770"
    },
    d: "M107.807,285.014c-21.098,0-38.262,17.165-38.262,38.262c0,21.097,17.165,38.262,38.262,38.262 s38.263-17.165,38.263-38.262C146.07,302.178,128.905,285.014,107.807,285.014z M107.807,346.331 c-12.712,0-23.054-10.342-23.054-23.054s10.342-23.054,23.054-23.054c12.713,0,23.055,10.342,23.055,23.054 S120.52,346.331,107.807,346.331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002770"
    },
    d: "M366.944,323.276c0,21.098,17.166,38.262,38.263,38.262s38.262-17.165,38.262-38.262 c0-21.097-17.165-38.262-38.262-38.262S366.944,302.178,366.944,323.276z M428.261,323.276c0,12.712-10.342,23.054-23.054,23.054 c-12.713,0-23.055-10.342-23.055-23.054s10.342-23.054,23.055-23.054C417.919,300.222,428.261,310.564,428.261,323.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002770"
    },
    d: "M256.507,285.014c-21.098,0-38.262,17.165-38.262,38.262c0,21.097,17.165,38.262,38.262,38.262 s38.262-17.165,38.262-38.262C294.769,302.178,277.605,285.014,256.507,285.014z M256.507,346.331 c-12.712,0-23.054-10.342-23.054-23.054s10.342-23.054,23.054-23.054c12.712,0,23.054,10.342,23.054,23.054 S269.219,346.331,256.507,346.331z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 197.875,
    y: 376.751,
    style: {
      fill: "#FFFFFF"
    },
    width: 117.273,
    height: 15.208
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.875,
    y: 407.167,
    style: {
      fill: "#FFFFFF"
    },
    width: 117.273,
    height: 15.208
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsites);
export default __webpack_public_path__ + "static/media/websites.e5e876100465ccefb9132a54a8ca144e.svg";
export { ForwardRef as ReactComponent };